import React, { useState } from 'react';
import FloatInput from 'components/generic-components/FloatInput';
import CustomButton from 'components/generic-components/ButtonComponent';
import SelectModal from 'components/SelectModal';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import {
    PAYMENTS
} from '../../../../constants/routes';
import { PaymentCkeckmark } from '../../../../components/Icons';
import { renderTime } from 'utils/functions';
import moment from 'moment';

const PaymentHistory = ({ view, isPaymentHistory }) => {
    const [show, setShow] = useState(false);
    const { t } = useTranslation();

    let paymentDate = moment(isPaymentHistory?.created_at).format("MMM D, yy")
    return (


        <div className={'payment-wrapper'} >

            <div className="payment-header d-flex">
                <div className="payment-header-date-container">
                    <div style={{ height: '24px' }}>
                        <span>{paymentDate}</span>
                    </div>
                    <span className="payment-header-time">{moment(isPaymentHistory?.created_at).format('LT')}</span>

                </div>
                <div className="payment-header-amount">
                    <span>{t(`Amount`)}</span>
                    <span><span className="currency-icon">₪</span>{isPaymentHistory.amount}</span>
                </div>
            </div>
            <div className="payment-footer d-flex">
                <div className="payment-footer-type">
                    <span>     {t(isPaymentHistory.type)}</span><span>{t(`to`)}</span>
                    <span>{isPaymentHistory.receiver.name}</span>
                </div>
                <div>
                    <PaymentCkeckmark />
                </div>
            </div>
        </div>


    );
};

export default PaymentHistory;
